import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { UserDetailView } from "@/views/user-detail/user-detail.view";
import { Route, Switch } from "wouter";
import { PhonebookView } from "./phonebook.view";

export function PhonebookRoutes() {
  const userUuidRegex = generateUuidV4Regex({ paramName: "userUuid" });

  return (
    <Switch>
      <Route path={userUuidRegex} component={UserDetailView} />
      <Route path={"/"} component={PhonebookView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
